import { SubMenuItemType } from "views/layout/components/CustomerSubmenu";
import { SubMenuItem } from "./SubMenuItem";

import "./Submenu.scss";

interface Props {
  menuItems: SubMenuItemType[];
  className: string;
}

export default function Submenu({ menuItems, className = "" }: Props) {
  return (
    <nav className={`menu ${className}`}>
      <ul>
        {menuItems.map((item, index) => (
          <SubMenuItem item={item} key={index}>
            {item.title}
          </SubMenuItem>
        ))}
      </ul>
    </nav>
  );
}
